export enum WireErrorCode {
  Referred = 'Referred',
  Declined = 'Declined',
}

export enum WireErrorRef {
  PromotionCode = 'PromotionCode',
}
